import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {DevilsCrossRoadGameMode} from "../../server/DevilsCrossRoadGameMode";
import {gsap} from "gsap";


export class ActivateSfsAnimations implements SimplePresentation {
    name: string = "ActivateSfsAnimations";

    shouldRun(): boolean {
        return (DevilsCrossRoad.model.data.mode !== DevilsCrossRoadGameMode.SUPER_FREESPIN && DevilsCrossRoad.model.data.nextMode === DevilsCrossRoadGameMode.SUPER_FREESPIN);
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl = gsap.timeline();

        tl.add(DevilsCrossRoad.freespinUnlockAreas.activateAnimation("top")); // TODO: Tmp, currently some reset issues between fs -> sfs
        tl.add(DevilsCrossRoad.freespinCollectorView.playAnimation("full"));
        tl.add(DevilsCrossRoad.freespinCollectorView.playAnimation("sfs"));
        tl.add(DevilsCrossRoad.freespinUnlockAreas.activateAnimation("right"));
        //tl.add(() => {console.log("ACTIVATE ANIM: " + this.name);});

        tl.add(() => controller.finish());
    }

}